import { render, staticRenderFns } from "./WorkplaceTable.vue?vue&type=template&id=0a83697b&"
import script from "./WorkplaceTable.vue?vue&type=script&lang=js&"
export * from "./WorkplaceTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports